import "./style.scss";
import * as React from "react";
import moment from "moment";
import {
  DatePicker as AntDDatePicker,
  TimePicker as AntDTimePicker
} from "antd";

interface IDatePicker {
  mode?: "time" | "date" | "month" | "year" | "range";
  value?: any;
  defaultValue?: any;
  disabledDate?: (cur: any) => boolean;
  disabledHours?: () => number[];
  showToday?: boolean;
  name: string;
  disabled?: boolean;
  handleChange: (e: any) => void;
  hideDisabledOptions?: boolean;
}

class DatePicker extends React.Component<IDatePicker, any> {
  handleChange(value: any) {
    let event = {
      target: {
        name: this.props.name,
        value: value
      }
    };

    this.props.handleChange(event);
  }

  render() {
    let {
      mode: mode = "date",
      value,
      name,
      defaultValue,
      handleChange,
      disabledDate,
      disabledHours,
      showToday,
      disabled,
      hideDisabledOptions
    } = this.props;

    switch (mode) {
      case "time":
        return (
          <AntDTimePicker
            use12Hours={false}
            value={value}
            disabledHours={disabledHours}
            defaultValue={defaultValue}
            disabled={disabled}
            onChange={this.handleChange.bind(this)}
            hideDisabledOptions={hideDisabledOptions}
          />
        );

      case "month":
      case "year":
      case "range":
      case "date":
      default:
        return (
          <AntDDatePicker
            value={value}
            defaultValue={defaultValue}
            disabledDate={disabledDate}
            showToday={showToday}
            disabled={disabled}
            onChange={this.handleChange.bind(this)}
          />
        );
    }
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./client/modules/form/DatePicker/index.tsx